import { render } from "./canvasWritePlay.vue?vue&type=template&id=172cafab&scoped=true"
import script from "./canvasWritePlay.vue?vue&type=script&lang=js"
export * from "./canvasWritePlay.vue?vue&type=script&lang=js"

import "./canvasWritePlay.vue?vue&type=style&index=0&id=172cafab&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-172cafab"]])

export default __exports__